// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-editor-component {\n    padding: 5px;\n}\n\n.layer-editor-type-image {\n    /* width: 32px !important; */\n    margin: 10px;\n    margin-right:13px;\n    margin-top:15px;\n    cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
